/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// product tabs
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".product-block-list__tabs_navigation a")
    .forEach(function (tabLink) {
      tabLink.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        // Remove the selected class from all tabs
        document
          .querySelector(".product-block-list__tabs_navigation a.selected")
          ?.classList.remove("selected");

        // Hide all tab contents
        document
          .querySelectorAll(".product-block-list__tab")
          .forEach(function (tabContent) {
            tabContent.style.display = "none";
          });

        // Add selected class to the clicked tab
        tabLink.classList.add("selected");

        // Show the corresponding tab content
        document.querySelector(tabLink.getAttribute("href")).style.display =
          "block";
      });
    });

  document
    .querySelector(".product-tab--description")
    .addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      // Get the first tab link
      var firstTabLink = document.querySelector(
        ".product-block-list__tabs_navigation ul li:first-child a"
      );

      // Remove the selected class from all tabs
      document
        .querySelector(".product-block-list__tabs_navigation a.selected")
        ?.classList.remove("selected");

      // Hide all tab contents
      document
        .querySelectorAll(".product-block-list__tab")
        .forEach(function (tabContent) {
          tabContent.style.display = "none";
        });

      // Add selected class to the first tab
      firstTabLink.classList.add("selected");

      // Show the corresponding tab content
      document.querySelector(firstTabLink.getAttribute("href")).style.display =
        "block";

      // Scroll to the product description
      window.scrollTo(
        0,
        document.getElementById("product-description").offsetTop
      );
    });
});

// reviews.io

const jumpToReviewsIO = () => {
  const links = document.querySelectorAll(
    ".product-block-list__tabs_navigation > ul > li > a"
  );
  if (links.length > 0) {
    // is product reviews selected, click it!
    if (!links[links.length - 1].classList.contains("selected")) {
      links[links.length - 1].click();
    }
    const target = document.getElementById("product-reviews-io");
    if (target) {
      window.scrollTo({
        top: target.offsetTop,
        behavior: "smooth",
      });
    }
  }
};

document
  .querySelectorAll(".ruk_rating_snippet, .ruk_read_reviews")
  .forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      jumpToReviewsIO();
    });
  });

document.querySelectorAll(".ruk_read_reviews").forEach((element) => {
  element.addEventListener("click", (event) => {
    event.preventDefault();
    jumpToReviewsIO();
  });
});

// Function to show the tooltip
function showTooltip(event) {
  const tooltipText = event.target.getAttribute("data-tooltip");

  if (!tooltipText) return;

  // Create tooltip element
  const tooltip = document.createElement("div");
  tooltip.className = "img-tooltip";
  tooltip.textContent = tooltipText;

  document.body.appendChild(tooltip);

  const targetRect = event.target.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  // Scroll position
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Position the tooltip above the element
  tooltip.style.left = `${
    targetRect.left + targetRect.width / 2 - tooltipRect.width / 2 + scrollLeft
  }px`;
  tooltip.style.top = `${
    targetRect.top + (targetRect.height + 10) + scrollTop
  }px`;

  // Show tooltip
  tooltip.classList.add("img-tooltip-visible");

  // Store the tooltip element on the target element for future reference
  event.target._tooltipElement = tooltip;
}

// Function to hide the tooltip
function hideTooltip(event) {
  const tooltip = event.target._tooltipElement;
  if (tooltip) {
    tooltip.remove(); // Remove the tooltip from the DOM
    event.target._tooltipElement = null;
  }
}

const uniqueAlts = [
  ...new Set(
    Array.from(document.querySelectorAll(".product-gallery__thumbnail")).map(
      (element) => {
        const img = element.querySelector("img");
        return img ? img.getAttribute("alt") : "";
      }
    )
  ),
];

document.querySelectorAll(".product-gallery__thumbnail").forEach((element) => {
  const img = element.querySelector("img");
  if (img && uniqueAlts.length > 1) {
    img.setAttribute("data-tooltip", img.getAttribute("alt"));
    img.classList.add("tooltip-trigger");
  }
});

// Attach event listeners to the tooltip triggers
document.querySelectorAll(".tooltip-trigger").forEach((trigger) => {
  trigger.addEventListener("mouseenter", showTooltip);
  trigger.addEventListener("mouseleave", hideTooltip);
});
